 /*
创建者 魏强(2018.1.29)
*/
<template>
    <div class="module-right">
        <ul class="prd-list clearfix">
            <li v-for="(item,index) in list" :key="index">
                <router-link :to="item.to" target="_blank">
                    <img :src="item.atturl" :alt="item.aname" height="218"  width="227" />
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
export default{
    props:["data"],
    data(){
        return {
            list : parseAdvList(this.data)
        }
    }
}
</script>



// WEBPACK FOOTER //
// right-ad.vue?41a774e2